import Iconify from '@emfood/shared/src/components/iconify';

import { Stack, Tooltip, useTheme } from '@mui/material';

export default function SurplusProductLabel() {
  const theme = useTheme();
  return (
    <Tooltip title="Surplus for redistribution">
      <Stack justifyContent="center" alignItems="center" minWidth={32} maxWidth={32}>
        <Iconify color={theme.palette.primary.darker} icon="solar:graph-up-bold" />
      </Stack>
    </Tooltip>
  );
}
